import { render } from "./DeleteResourceModal.vue?vue&type=template&id=593c0d2e"
import script from "./DeleteResourceModal.vue?vue&type=script&lang=js"
export * from "./DeleteResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DeleteResourceModal.vue"]])

export default __exports__